<header>
    <nav>
        <a routerLink="">
            <img src="../../../assets/angular-firebase.png" alt="">
        </a>
        <a routerLink="user">User-Register</a>
        <a routerLink="user-list">User-list</a>

    </nav>
</header>